import styled from "styled-components";

export const Container = styled.div`
  width: fit-content;
  padding: 6px;
  border-radius: 10px;
  margin: 0 auto;
`;